import { IDENTITY_PROVIDER_TYPES } from '@lumapps/providers/constants';

export const COMPACT_LOGIN_LIST_LENGTH = 15;

/**
 * Error codes the backend can send on the login page's `error` query param.
 *
 * An allow-list, not an index into `SIGN_IN`: indexing also resolved `Object.prototype` members and
 * non-error members, putting arbitrary strings into the banner's `dangerouslySetInnerHTML`. An
 * unlisted code falls back to the generic message.
 */
export const LOGIN_ERROR_CODES = [
    '2FA_NO_EMAIL',
    'GENERIC_ERROR_LOGIN',
    'INVALID_CAPTCHA',
    'INVALID_LOGIN',
    'INVALID_LOGIN_SESSION_EXPIRED',
    'INVALID_SAML_CONFIGURATION',
    'NEED_LOGIN',
    'NOT_AUTHORIZED_LOGIN',
    'PASSWORD_API_UPDATE_ERROR',
    'TOO_MANY_ATTEMPTS',
    'USER_CREATION_FAILED',
] as const;

export type LoginErrorCode = (typeof LOGIN_ERROR_CODES)[number];

export interface LogoutUrlProps {
    url: string;
}
export const LOGOUT_URL: Record<any, LogoutUrlProps> = {
    [IDENTITY_PROVIDER_TYPES.GOOGLE]: {
        url: 'https://accounts.google.com/logout',
    },
    [IDENTITY_PROVIDER_TYPES.MICROSOFT]: {
        url: 'https://login.microsoftonline.com/logout.srf',
    },
};
